import { call, put } from 'redux-saga/effects';
import { showToastMessage } from '../../services/notification';

import api, { makeOptions } from '../../services/api';
import ReminderListActions from '../ducks/reminder-list';

const dataLocal = JSON.parse(localStorage.getItem('persist:Spcine'));
// const getAuthData = (state) => state.auth.data;

export function* fetch(action) {
  try {
    // const authData = yield select(getAuthData);
    const { params = {} } = action;

    // filters
    const reminderType = !params.reminderType
      ? ''
      : `?filters[0][reminder_type.name@equal]=${params.reminderType}`;

    const url = `/reminder${reminderType}`;

    const { data: responseData } = yield call(
      api.get,
      url,
      makeOptions(dataLocal.auth.data),
    );
    const { data, ...pagination } = responseData;
    yield put(ReminderListActions.success(data, pagination));
  } catch (err) {
    yield put(ReminderListActions.failure(err.response.data.error.message));
    showToastMessage({
      type: 'error',
      text: err.response.data.error.message,
    });
  }
}

export function* fetchSelect() {
  try {
    // const authData = yield select(getAuthData);
    const url = `/reminder?paginate=false`;
    const { data: responseData } = yield call(
      api.get,
      url,
      makeOptions(dataLocal.auth.data),
    );
    const { data } = responseData;

    const list = data.map(({ uuid, title }) => ({
      value: uuid,
      label: title,
    }));

    yield put(ReminderListActions.showSuccess(list));
  } catch (err) {
    yield put(ReminderListActions.showFailure(err.response.data.error.message));
    showToastMessage({
      type: 'error',
      text: err.response.data.error.message,
    });
  }
}
